import type { SxProps, Theme } from '@mui/material/styles';
import type { OperatorType } from '../OperatorChip.tsx';

export const getChipContainerStyles = (hideDivider?: boolean): SxProps<Theme> => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  position: 'relative',
  my: 1.5,

  ...(hideDivider && {
    my: 0,
    display: 'block',
    width: 'fit-content',
  }),
});

export const chipBaseStyles = (hideDivider = false): SxProps<Theme> => ({
  borderRadius: '50px',
  padding: '2px 12px',
  minWidth: 'auto',
  height: '24px',
  textTransform: 'uppercase',
  fontWeight: 'fontWeightBold',
  fontSize: '11px',
  lineHeight: 1,
  zIndex: 1,
  position: 'relative',
  marginLeft: hideDivider ? 0 : '8px',
  marginRight: hideDivider ? 0 : '8px',
});

export const getOperatorChipStyles = (operator: OperatorType | (string & {}), hideDivider = false): SxProps<Theme> => {
  const base = chipBaseStyles(hideDivider);

  switch (operator) {
    case 'AND':
      return {
        ...base,
        backgroundColor: 'primary.light',
        color: 'primary.main',
        borderColor: 'primary.border',
        '&:hover': {
          backgroundColor: 'primary.light',
          borderColor: 'primary.border',
          filter: 'brightness(0.95)',
        },
        '&:active': {
          backgroundColor: 'primary.light',
          borderColor: 'primary.border',
          filter: 'brightness(0.9)',
        },
      };

    case 'EXCLUDE':
      return {
        ...base,
        backgroundColor: 'error.light',
        color: 'error.dark',
        borderColor: 'error.border',
        '&:hover': {
          filter: 'brightness(0.95)',
        },
        '&:active': {
          filter: 'brightness(0.9)',
        },
      };
    default:
      return {
        ...base,
        backgroundColor: 'success.light',
        color: 'success.dark',
        borderColor: 'success.border',
        '&:hover': {
          backgroundColor: 'success.light',
          borderColor: 'success.border',
          filter: 'brightness(0.95)',
        },
        '&:active': {
          backgroundColor: 'success.light',
          borderColor: 'success.border',
          filter: 'brightness(0.9)',
        },
      };
  }
};
